<template>
    <div class="short-channel-order-form-page-2">
        <div class="d-flex align-items-center mb-4">
            <div class="flex-fill">
                <div class="alert alert-info text-center mb-0">
                    La commande n'est pas encore enregistrée, n'oubliez pas de valider.
                </div>
            </div>
            <div class="ml-3">
                <slot name="submitButton" :on-click-next="onClickNext"></slot>
            </div>
        </div>

        <form ref="form" enctype="multipart/form-data">
            <div class="form-group row">
                <label for="customer" class="col-md-3 col-form-label">Circuit court</label>
                <div class="col-md-9">
                    <input type="text" class="form-control-plaintext" id="customer" :value="customer.name" readonly>
                </div>
            </div>
            <div class="form-group row">
                <label for="customer" class="col-md-3 col-form-label">Type de circuit court</label>
                <div class="col-md-9">
                    <input type="text" class="form-control-plaintext" id="customer_channel_type" :value="channelType" readonly>
                </div>
            </div>
            <div class="form-group row">
                <label for="deliveryDate" class="col-md-3 col-form-label">Date de livraison</label>
                <div class="col-md-9">
                    <input type="text" class="form-control-plaintext" id="deliveryDate" :value="formattedDeliveryDate" readonly>
                </div>
            </div>
            <div class="form-group row">
                <label for="endPreparationDate" class="col-md-3 col-form-label">Date de fin de préparation</label>
                <div class="col-md-9">
                    <input type="text" class="form-control-plaintext" id="endPreparationDate" :value="formattedEndPreparationDate" readonly>
                </div>
            </div>
            <div class="form-group row">
                <label for="csv" class="col-md-3 col-form-label">
                    Sélectionner le fichier {{fileTypeName}} contenant les commandes à importer
                    <a href="#" @click="$refs.findLrqdoModal.showModal()" v-if="channelType == 'La Ruche qui dit Oui'">
                        <i class="fad fa-info-circle"></i>
                    </a>
                    <a href="#" @click="$refs.findLocavorModal.showModal()" v-if="channelType == 'Locavor'">
                        <i class="fad fa-info-circle"></i>
                    </a>
                    <a href="#" @click="$refs.findAmapJModal.showModal()" v-if="channelType == 'AmapJ'">
                        <i class="fad fa-info-circle"></i>
                    </a>
                </label>
                <div class="col-md-9">
                    <div class="custom-file">
                        <input class="form-control-file custom-file-input" type="file" id="csv" name="csv" lang="fr" @change="fileChange($event.target.files)" :accept="fileTypeMime">
                        <label class="custom-file-label" for="csv">Choisir un {{fileTypeName}}</label>
                    </div>
                    <a :href="`/espace-employes/commandes/commande-circuit-court/creation/${customer.id}/telecharger-modele/${endPreparationDateYmd}`" target="_blank"
                        v-if="channelType == 'Cérès'">
                        <i class="fad fa-download"></i> Télécharger le modèle Excel (xslx)
                    </a>
                    <a href="#" @click="$refs.findLrqdoModal.showModal()" v-if="channelType == 'La Ruche qui dit Oui'">
                        <i class="fad fa-info-circle"></i> Où trouver le fichier pour La Ruche qui dit Oui ?
                    </a>
                    <a href="#" @click="$refs.findLocavorModal.showModal()" v-if="channelType == 'Locavor'">
                        <i class="fad fa-info-circle"></i> Où trouver le fichier pour Locavor.fr ?
                    </a>
                    <template v-if="channelType == 'AmapJ'">
                        <div>
                            <a href="#" @click="$refs.findAmapJModal.showModal()">
                                <i class="fad fa-info-circle"></i> Où trouver le fichier pour AmapJ ?
                            </a>
                        </div>
                        <div>
                            <a href="#" @click="$refs.findAmapJModal.showModal()" v-if="channelType == 'AmapJ'" class="text-warning">
                                <i class="fad fa-exclamation-triangle"></i> L'import AmapJ nécessite des actions particulières lors de la création de la vente.
                            </a>
                        </div>
                    </template>
                </div>
                <div v-if="order" class="alert alert-warning">
                    <b>NE SELECTIONNEZ PAS</b> de fichier si vous souhaitez garder les commandes existantes. Cliquez directement sur le bouton pour passer à la page suivante.<br>
                    Si vous sélectionnez un fichier, les commandes existantes et leurs produits seront remplacés par les commandes du fichier et il faudra recommencer la préparation de la commande depuis le début.
                </div>
            </div>
            <div v-if="fileLoaded && hasOrders" class="form-group row">
                <div class="col-md-3">
                    La commande est-elle définitive et prête à être préparée ?
                </div>
                <div class="col-md-9">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" id="readyToPrepare" v-model="readyToPrepare">
                        <label class="custom-control-label" for="readyToPrepare">{{ readyToPrepare ? 'Oui, la préparation peut commencer' : 'Non, la préparation sera bloquée pour le moment' }}</label>
                    </div>
                </div>
            </div>
        </form>

        <template>
            <modal ref="findLrqdoModal">
                <template #body="sp">
                    <h4>Où trouver le fichier La Ruche Qui Dit Oui ?</h4>
                    <p>
                         - Se rendre sur la
                        <a href="https://laruchequiditoui.fr/fr/producers/me/collections" target="_blank">
                            page "Distributions"
                        </a><br />
                         - Au niveau de la distribution choisie, cliquer sur "Télécharger les documents"<br />
                         - Dans la section "Bon de préparation", choisir "CSV" et cliquer sur "Télécharger"<br />
                    </p>
                    <p>
                        <a href="/img/csv-export-lrqdo.gif" target="_blank">
                            <img src="/img/csv-export-lrqdo.gif" style="width: 80%" />
                        </a>
                    </p>
                </template>
                <template #footer>
                    <button class="btn btn-secondary" @click="$refs.findLrqdoModal.closeModal()">
                        Fermer
                    </button>
                </template>
            </modal>
            <modal ref="findLocavorModal">
                <template #body="sp">
                    <h4>Où trouver le fichier Locavor.fr ?</h4>
                    <p>
                        - Se rendre sur la
                        <a href="https://locavor.fr/vente/fournisseur" target="_blank">
                            page "Les ventes"
                        </a><br />
                        - Au niveau de la vente choisie, cliquer sur "<i class="fas fa-eye"></i> COMMANDES"<br />
                        - En haut à doite, cliquer sur "CSV" puis sur "Par membres"<br />
                    </p>
                    <p>
                        <a href="/img/csv-export-locavor.gif" target="_blank">
                            <img src="/img/csv-export-locavor.gif" style="width: 80%" />
                        </a>
                    </p>
                </template>
                <template #footer>
                    <button class="btn btn-secondary" @click="$refs.findLocavorModal.closeModal()">
                        Fermer
                    </button>
                </template>
            </modal>
            <modal ref="findAmapJModal" size="large">
                <template #body="sp">
                    <h4>Où trouver le fichier AmapJ ?</h4>
                    <p>
                         - Se rendre sur la page "Livraisons d'un producteur"<br />
                         - Au niveau de la distribution choisie, cliquer sur "Télécharger la feuille de distribution producteur du xxxxx"<br />
                    </p>
                    <p>
                        <a href="/img/xls-export-amapj.gif" target="_blank">
                            <img src="/img/xls-export-amapj.gif" style="max-width: 300px" />
                        </a>
                    </p>
                    <div class="alert alert-warning">
                        <b>Attention</b> : Pour que les fichiers AmapJ puissent être importés, les conditions suivantes doivent être remplies :<br />
                        - Pour une date de livraison/distribution donnée, un seul contrat producteur doit exister dans AmapJ, il n'est pas possible de découper la vente en plusieurs contrats.<br />
                        - Les produits doivent être enregistrés dans AmapJ avec leur SKU indiqué entre parenthèses à la fin du champ "Nom" (exemple: "Pain de blé (PAIN-BLE)") et/ou du champ "Conditionnement" (exemple: "930g (PAIN-BLE)").<br />
                        <a href="/img/amapj-products-sku.png" target="_blank">
                            <img src="/img/amapj-products-sku.png" style="max-width: 300px" />
                        </a><br />
                        Les SKU et informations produit sont disponibles dans le catalogue produit (téléchargeable depuis la <a :href="`/espace-employes/clients/${customer.id}`" target="_blank">page "clients" de Cérès</a>).
                    </div>
                </template>
                <template #footer>
                    <button class="btn btn-secondary" @click="$refs.findAmapJModal.closeModal()">
                        Fermer
                    </button>
                </template>
            </modal>
        </template>

        <template v-if="fileLoaded">
            <div v-if="hasOrders" class="row">
                <template v-for="customerOrder in generatedOrder.orders">
                    <div class="col-md-12 mt-3" :key="customerOrder.ref">
                        <div class="row">
                            <div class="col-md-12 h4">
                                Commande {{ customerOrder.ref }} pour {{ customerOrder.subcustomer_name || 'inconnu' }}
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <table class="table table-bordered table-sm table-hover">
                                    <thead>
                                        <tr>
                                            <th class="col-quantity">Quantité</th>
                                            <th class="col-sku">SKU</th>
                                            <th class="col-description">Produit</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="line in customerOrder.lines">
                                            <td>{{ line.quantity }}</td>
                                            <td>{{ line.sku }}</td>
                                            <td>{{ line.description }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div v-else class="row">
                <div class="col-md-12">
                    <div class="alert alert-danger">
                        {{ "Erreur : " + (fileLoadError || "Aucune commande trouvée dans le fichier pour ce circuit court.") }}<br>
                        Vérifiez que le nom et la date du circuit court sélectionné sont bien présents dans le nom du fichier sélectionné ou dans le fichier lui-même au niveau des lignes des commandes.
                    </div>
                </div>
            </div>
        </template>

        <div class="row">
            <div class="col-md-12">
                <slot name="alerts"></slot>

                <slot name="errors"></slot>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <hr>

                <button type="button" class="btn btn-outline-dark float-left" @click="onClickBack" :disabled="loading || sending">
                    <i class="fas fa-chevron-left"></i> Retourner au panier
                </button>

                <slot name="submitButton" :on-click-next="onClickNext"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import ErrorsZone from "../ErrorsZone"

    import {momentDay} from "../../moment-with-helpers"

    export default {
        components: {
            ErrorsZone
        },

        props: {
            order: {
                type: Object,
                required: false,
            },
            customer: {
                type: Object,
                required: true,
            },
            deliveryDate: {
                type: Object,
                required: true,
            },
            endPreparationDate: {
                type: Object,
                required: true,
            },
            authorizationToken: {
                type: String,
                required: false,
                default: '',
            },
            errors: {
                required: false,
            },
            loading: {
                type: Boolean,
                required: true,
            },
            sending: {
                type: Boolean,
                required: true,
            },
        },

        data() {
            return {
                generatedOrder: null,
                fileLoaded: false,
                fileLoadError: null,
                readyToPrepare: true,
            };
        },

        mounted() {
            this.$emit('mounted');
        },

        methods: {
            fileChange(file) {
                this.generatedOrder = null;
                this.fileLoaded = false;
                this.fileLoadError = null;

                const formData = new FormData();
                formData.append('delivery_date', this.deliveryDateYmd);
                formData.append('csv', file[0]);

                axios.post(`/espace-employes/commandes/commande-circuit-court/creation/${this.customer.id}/csv-process`, formData)
                    .then(res => {
                        if (res.data.error) {
                            this.fileLoadError = res.data.error;
                        } else {
                            this.generatedOrder = res.data.order || null;
                        }
                    })
                    .catch(err => {
                        if (err.response && err.response.data && (err.response.data.message || err.response.data.error)) {
                            this.fileLoadError = err.response.data.message || err.response.data.error;
                        }
                    })
                    .finally(() => {
                        this.fileLoaded = true;

                        this.$emit('orders-updated', this.generatedOrder && this.generatedOrder.orders);
                    });
            },

            onClickBack() {
                this.$emit('back');
            },

            onClickNext() {
                this.$emit('submit', {
                    orders: (this.generatedOrder && this.generatedOrder.orders) || null,
                    readyToPrepare: this.readyToPrepare,
                });
            },
        },

        computed: {
            canClickNext() {
                return ((this.hasOrders && this.fileLoaded) || (!this.hasOrders && !this.fileLoaded && this.order)) && !this.fileLoadError;
            },

            hasOrders() {
                return this.generatedOrder && this.generatedOrder.orders && Object.keys(this.generatedOrder.orders).length > 0;
            },

            formattedDeliveryDate() {
                return momentDay(this.deliveryDate.date).format('dddd Do MMMM YYYY');
            },

            deliveryDateYmd() {
                return momentDay(this.deliveryDate.date).format('YYYY-MM-DD');
            },

            formattedEndPreparationDate() {
                return momentDay(this.endPreparationDate.date).format('dddd Do MMMM YYYY');
            },

            endPreparationDateYmd() {
                return momentDay(this.endPreparationDate.date).format('YYYY-MM-DD');
            },

            channelType() {
                if(this.customer && this.customer.meta) {
                    return this.customer.meta.channel_type;
                }
                return null;
            },

            fileType() {
                switch(this.channelType) {
                    case 'Cérès':
                        return 'xlsx';
                    case 'AmapJ':
                        return 'xls';
                    default:
                        return 'csv';
                }
            },

            fileTypeName() {
                switch(this.fileType) {
                    case 'xlsx':
                        return 'Document Excel (.xlsx)';
                    case 'xls':
                        return 'Document Excel (.xls)';
                    default:
                        return 'CSV';
                }
            },

            fileTypeMime() {
                switch(this.fileType) {
                    case 'xlsx':
                        return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                    case 'xls':
                        return 'application/vnd.ms-excel';
                    default:
                        return 'text/csv';
                }
            },
        }
    }
</script>

<style scoped>
    .col-sku {
        min-width: 150px;
    }

    .col-quantity {
        min-width: 100px;
    }

    .col-description {
        width: 100%;
    }
</style>
